export default __webpack_public_path__ + "images/32fc1a39d80a8da40d4fe8317ee825aa-knowing_when_you_need_help.svg";